function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { isValidElement, useRef, useState, useCallback, useEffect, useMemo, createContext, useContext, createElement, cloneElement } from 'react';

var isHTMLElement = function isHTMLElement(value) {
  return value instanceof HTMLElement;
};

var EVENTS = {
  BLUR: 'blur',
  CHANGE: 'change',
  INPUT: 'input'
};
var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
var SELECT = 'select';
var UNDEFINED = 'undefined';
var INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};

function attachEventListeners(_ref, shouldAttachChangeEvent, handleChange) {
  var ref = _ref.ref;

  if (isHTMLElement(ref) && handleChange) {
    ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
    ref.addEventListener(EVENTS.BLUR, handleChange);
  }
}

var isNullOrUndefined = function isNullOrUndefined(value) {
  return value == null;
};

var isObjectType = function isObjectType(value) {
  return _typeof(value) === 'object';
};

var isObject = function isObject(value) {
  return !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !(value instanceof Date);
};

var isKey = function isKey(value) {
  return /^\w*$/.test(value);
};

var compact = function compact(value) {
  return value.filter(Boolean);
};

var stringToPath = function stringToPath(input) {
  return compact(input.replace(/["|']/g, '').replace(/\[/g, '.').replace(/\]/g, '').split('.'));
};

function set(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath(path);
  var length = tempPath.length;
  var lastIndex = length - 1;

  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;

    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }

    object[key] = newValue;
    object = object[key];
  }

  return object;
}

var transformToNestObject = function transformToNestObject(data) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var key in data) {
    !isKey(key) ? set(value, key, data[key]) : value[key] = data[key];
  }

  return value;
};

var isUndefined = function isUndefined(val) {
  return val === undefined;
};

var _get = function get() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments.length > 1 ? arguments[1] : undefined;
  var defaultValue = arguments.length > 2 ? arguments[2] : undefined;
  var result = compact(path.split(/[,[\].]+?/)).reduce(function (result, key) {
    return isNullOrUndefined(result) ? result : result[key];
  }, obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};

var focusOnErrorField = function focusOnErrorField(fields, fieldErrors) {
  for (var key in fields) {
    if (_get(fieldErrors, key)) {
      var field = fields[key];

      if (field) {
        if (field.ref.focus && isUndefined(field.ref.focus())) {
          break;
        } else if (field.options) {
          field.options[0].ref.focus();
          break;
        }
      }
    }
  }
};

var removeAllEventListeners = function removeAllEventListeners(ref, validateWithStateUpdate) {
  if (isHTMLElement(ref) && ref.removeEventListener) {
    ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
  }
};

var defaultReturn = {
  isValid: false,
  value: null
};

var getRadioValue = function getRadioValue(options) {
  return Array.isArray(options) ? options.reduce(function (previous, option) {
    return option && option.ref.checked ? {
      isValid: true,
      value: option.ref.value
    } : previous;
  }, defaultReturn) : defaultReturn;
};

var getMultipleSelectValue = function getMultipleSelectValue(options) {
  return _toConsumableArray(options).filter(function (_ref2) {
    var selected = _ref2.selected;
    return selected;
  }).map(function (_ref3) {
    var value = _ref3.value;
    return value;
  });
};

var isRadioInput = function isRadioInput(element) {
  return element.type === 'radio';
};

var isFileInput = function isFileInput(element) {
  return element.type === 'file';
};

var isCheckBoxInput = function isCheckBoxInput(element) {
  return element.type === 'checkbox';
};

var isMultipleSelect = function isMultipleSelect(element) {
  return element.type === "".concat(SELECT, "-multiple");
};

var defaultResult = {
  value: false,
  isValid: false
};
var validResult = {
  value: true,
  isValid: true
};

var getCheckboxValue = function getCheckboxValue(options) {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      var values = options.filter(function (option) {
        return option && option.ref.checked;
      }).map(function (_ref4) {
        var value = _ref4.ref.value;
        return value;
      });
      return {
        value: values,
        isValid: !!values.length
      };
    }

    var _options$0$ref = options[0].ref,
        checked = _options$0$ref.checked,
        value = _options$0$ref.value,
        attributes = _options$0$ref.attributes;
    return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || value === '' ? validResult : {
      value: value,
      isValid: true
    } : validResult : defaultResult;
  }

  return defaultResult;
};

function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled, shouldKeepRawValue) {
  var field = fieldsRef.current[name];

  if (field) {
    var _field$ref = field.ref,
        value = _field$ref.value,
        disabled = _field$ref.disabled,
        ref = field.ref,
        valueAsNumber = field.valueAsNumber,
        valueAsDate = field.valueAsDate,
        setValueAs = field.setValueAs;

    if (disabled && excludeDisabled) {
      return;
    }

    if (isFileInput(ref)) {
      return ref.files;
    }

    if (isRadioInput(ref)) {
      return getRadioValue(field.options).value;
    }

    if (isMultipleSelect(ref)) {
      return getMultipleSelectValue(ref.options);
    }

    if (isCheckBoxInput(ref)) {
      return getCheckboxValue(field.options).value;
    }

    return shouldKeepRawValue ? value : valueAsNumber ? value === '' ? NaN : +value : valueAsDate ? ref.valueAsDate : setValueAs ? setValueAs(value) : value;
  }

  if (shallowFieldsStateRef) {
    return _get(shallowFieldsStateRef.current, name);
  }
}

function isDetached(element) {
  if (!element) {
    return true;
  }

  if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
    return false;
  }

  return isDetached(element.parentNode);
}

var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && !Object.keys(value).length;
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

function baseGet(object, updatePath) {
  var length = updatePath.slice(0, -1).length;
  var index = 0;

  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }

  return object;
}

function unset(object, path) {
  var updatePath = isKey(path) ? [path] : stringToPath(path);
  var childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
  var key = updatePath[updatePath.length - 1];
  var previousObjRef;

  if (childObject) {
    delete childObject[key];
  }

  for (var k = 0; k < updatePath.slice(0, -1).length; k++) {
    var index = -1;
    var objectRef = void 0;
    var currentPaths = updatePath.slice(0, -(k + 1));
    var currentPathsLength = currentPaths.length - 1;

    if (k > 0) {
      previousObjRef = object;
    }

    while (++index < currentPaths.length) {
      var item = currentPaths[index];
      objectRef = objectRef ? objectRef[item] : object[item];

      if (currentPathsLength === index && (isObject(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter(function (data) {
        return isObject(data) && !isEmptyObject(data) || isBoolean(data);
      }).length)) {
        previousObjRef ? delete previousObjRef[item] : delete object[item];
      }

      previousObjRef = objectRef;
    }
  }

  return object;
}

var isSameRef = function isSameRef(fieldValue, ref) {
  return fieldValue && fieldValue.ref === ref;
};

function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
  var ref = field.ref,
      name = field.ref.name;
  var fieldRef = fieldsRef.current[name];

  if (!shouldUnregister) {
    var value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
    !isUndefined(value) && set(shallowFieldsStateRef.current, name, value);
  }

  if (!ref.type || !fieldRef) {
    delete fieldsRef.current[name];
    return;
  }

  if (isRadioInput(ref) || isCheckBoxInput(ref)) {
    if (Array.isArray(fieldRef.options) && fieldRef.options.length) {
      compact(fieldRef.options).forEach(function () {
        var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;

        if (isDetached(option.ref) && isSameRef(option, option.ref) || forceDelete) {
          removeAllEventListeners(option.ref, handleChange);
          unset(fieldRef.options, "[".concat(index, "]"));
        }
      });

      if (fieldRef.options && !compact(fieldRef.options).length) {
        delete fieldsRef.current[name];
      }
    } else {
      delete fieldsRef.current[name];
    }
  } else if (isDetached(ref) && isSameRef(fieldRef, ref) || forceDelete) {
    removeAllEventListeners(ref, handleChange);
    delete fieldsRef.current[name];
  }
}

var isPrimitive = function isPrimitive(value) {
  return isNullOrUndefined(value) || !isObjectType(value);
};

function deepMerge(target, source) {
  if (isPrimitive(target) || isPrimitive(source)) {
    return source;
  }

  for (var key in source) {
    var targetValue = target[key];
    var sourceValue = source[key];

    try {
      target[key] = isObject(targetValue) && isObject(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? deepMerge(targetValue, sourceValue) : sourceValue;
    } catch (_a) {}
  }

  return target;
}

function deepEqual(object1, object2, isErrorObject) {
  if (isPrimitive(object1) || isPrimitive(object2) || object1 instanceof Date || object2 instanceof Date) {
    return object1 === object2;
  }

  if (!isValidElement(object1)) {
    var keys1 = Object.keys(object1);
    var keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
      var key = _keys[_i];
      var val1 = object1[key];

      if (!(isErrorObject && key === 'ref')) {
        var val2 = object2[key];

        if ((isObject(val1) || Array.isArray(val1)) && (isObject(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, isErrorObject) : val1 !== val2) {
          return false;
        }
      }
    }
  }

  return true;
}

function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
  var index = -1;

  while (++index < values.length) {
    for (var key in values[index]) {
      if (Array.isArray(values[index][key])) {
        !dirtyFields[index] && (dirtyFields[index] = {});
        dirtyFields[index][key] = [];
        setDirtyFields(values[index][key], _get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
      } else {
        deepEqual(_get(defaultValues[index] || {}, key), values[index][key]) ? set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), _defineProperty({}, key, true));
      }
    }

    parentNode && !dirtyFields.length && delete parentNode[parentName];
  }

  return dirtyFields;
}

var setFieldArrayDirtyFields = function setFieldArrayDirtyFields(values, defaultValues, dirtyFields) {
  return deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));
};

var isString = function isString(value) {
  return typeof value === 'string';
};

var getFieldsValues = function getFieldsValues(fieldsRef, shallowFieldsState, shouldUnregister, excludeDisabled, search) {
  var output = {};

  var _loop = function _loop(name) {
    if (isUndefined(search) || (isString(search) ? name.startsWith(search) : Array.isArray(search) && search.find(function (data) {
      return name.startsWith(data);
    }))) {
      output[name] = getFieldValue(fieldsRef, name, undefined, excludeDisabled);
    }
  };

  for (var name in fieldsRef.current) {
    _loop(name);
  }

  return shouldUnregister ? transformToNestObject(output) : deepMerge(shallowFieldsState, transformToNestObject(output));
};

var isErrorStateChanged = function isErrorStateChanged(_ref5) {
  var errors = _ref5.errors,
      name = _ref5.name,
      error = _ref5.error,
      validFields = _ref5.validFields,
      fieldsWithValidation = _ref5.fieldsWithValidation;
  var isValid = isUndefined(error);

  var previousError = _get(errors, name);

  return isValid && !!previousError || !isValid && !deepEqual(previousError, error, true) || isValid && _get(fieldsWithValidation, name) && !_get(validFields, name);
};

var isRegex = function isRegex(value) {
  return value instanceof RegExp;
};

var getValueAndMessage = function getValueAndMessage(validationData) {
  return isObject(validationData) && !isRegex(validationData) ? validationData : {
    value: validationData,
    message: ''
  };
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isMessage = function isMessage(value) {
  return isString(value) || isValidElement(value);
};

function getValidateError(result, ref) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';

  if (isMessage(result) || isBoolean(result) && !result) {
    return {
      type: type,
      message: isMessage(result) ? result : '',
      ref: ref
    };
  }
}

var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
  return validateAllFieldCriteria ? Object.assign(Object.assign({}, errors[name]), {
    types: Object.assign(Object.assign({}, errors[name] && errors[name].types ? errors[name].types : {}), _defineProperty({}, type, message || true))
  }) : {};
};

var validateField = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldsRef, validateAllFieldCriteria, _ref6, shallowFieldsStateRef) {
    var ref, value, options, required, maxLength, minLength, min, max, pattern, validate, name, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref8, _value, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, maxLengthOutput, minLengthOutput, _exceedMax, _exceedMin, _getValueAndMessage, patternValue, _message, fieldValue, validateRef, result, validateError, validationResult, _i2, _Object$entries, _ref11, _ref10, key, validateFunction, validateResult, _validateError;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ref = _ref6.ref, value = _ref6.ref.value, options = _ref6.options, required = _ref6.required, maxLength = _ref6.maxLength, minLength = _ref6.minLength, min = _ref6.min, max = _ref6.max, pattern = _ref6.pattern, validate = _ref6.validate;
            name = ref.name;
            error = {};
            isRadio = isRadioInput(ref);
            isCheckBox = isCheckBoxInput(ref);
            isRadioOrCheckbox = isRadio || isCheckBox;
            isEmpty = value === '';
            appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

            getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
              var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
              var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
              var message = exceedMax ? maxLengthMessage : minLengthMessage;
              error[name] = Object.assign({
                type: exceedMax ? maxType : minType,
                message: message,
                ref: ref
              }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));
            };

            if (!(required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid))) {
              _context.next = 15;
              break;
            }

            _ref8 = isMessage(required) ? {
              value: !!required,
              message: required
            } : getValueAndMessage(required), _value = _ref8.value, message = _ref8.message;

            if (!_value) {
              _context.next = 15;
              break;
            }

            error[name] = Object.assign({
              type: INPUT_VALIDATION_RULES.required,
              message: message,
              ref: isRadioOrCheckbox ? ((fieldsRef.current[name].options || [])[0] || {}).ref : ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));

            if (validateAllFieldCriteria) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", error);

          case 15:
            if (!((!isNullOrUndefined(min) || !isNullOrUndefined(max)) && value !== '')) {
              _context.next = 23;
              break;
            }

            maxOutput = getValueAndMessage(max);
            minOutput = getValueAndMessage(min);

            if (!isNaN(value)) {
              valueNumber = ref.valueAsNumber || parseFloat(value);

              if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
              }

              if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
              }
            } else {
              valueDate = ref.valueAsDate || new Date(value);

              if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
              }

              if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
              }
            }

            if (!(exceedMax || exceedMin)) {
              _context.next = 23;
              break;
            }

            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

            if (validateAllFieldCriteria) {
              _context.next = 23;
              break;
            }

            return _context.abrupt("return", error);

          case 23:
            if (!(isString(value) && !isEmpty && (maxLength || minLength))) {
              _context.next = 32;
              break;
            }

            maxLengthOutput = getValueAndMessage(maxLength);
            minLengthOutput = getValueAndMessage(minLength);
            _exceedMax = !isNullOrUndefined(maxLengthOutput.value) && value.length > maxLengthOutput.value;
            _exceedMin = !isNullOrUndefined(minLengthOutput.value) && value.length < minLengthOutput.value;

            if (!(_exceedMax || _exceedMin)) {
              _context.next = 32;
              break;
            }

            getMinMaxMessage(_exceedMax, maxLengthOutput.message, minLengthOutput.message);

            if (validateAllFieldCriteria) {
              _context.next = 32;
              break;
            }

            return _context.abrupt("return", error);

          case 32:
            if (!(isString(value) && pattern && !isEmpty)) {
              _context.next = 38;
              break;
            }

            _getValueAndMessage = getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, _message = _getValueAndMessage.message;

            if (!(isRegex(patternValue) && !patternValue.test(value))) {
              _context.next = 38;
              break;
            }

            error[name] = Object.assign({
              type: INPUT_VALIDATION_RULES.pattern,
              message: _message,
              ref: ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, _message));

            if (validateAllFieldCriteria) {
              _context.next = 38;
              break;
            }

            return _context.abrupt("return", error);

          case 38:
            if (!validate) {
              _context.next = 74;
              break;
            }

            fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef, false, true);
            validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;

            if (!isFunction(validate)) {
              _context.next = 52;
              break;
            }

            _context.next = 44;
            return validate(fieldValue);

          case 44:
            result = _context.sent;
            validateError = getValidateError(result, validateRef);

            if (!validateError) {
              _context.next = 50;
              break;
            }

            error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

            if (validateAllFieldCriteria) {
              _context.next = 50;
              break;
            }

            return _context.abrupt("return", error);

          case 50:
            _context.next = 74;
            break;

          case 52:
            if (!isObject(validate)) {
              _context.next = 74;
              break;
            }

            validationResult = {};
            _i2 = 0, _Object$entries = Object.entries(validate);

          case 55:
            if (!(_i2 < _Object$entries.length)) {
              _context.next = 70;
              break;
            }

            _ref11 = _Object$entries[_i2];
            _ref10 = _slicedToArray(_ref11, 2);
            key = _ref10[0];
            validateFunction = _ref10[1];

            if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
              _context.next = 62;
              break;
            }

            return _context.abrupt("break", 70);

          case 62:
            _context.next = 64;
            return validateFunction(fieldValue);

          case 64:
            validateResult = _context.sent;
            _validateError = getValidateError(validateResult, validateRef, key);

            if (_validateError) {
              validationResult = Object.assign(Object.assign({}, _validateError), appendErrorsCurry(key, _validateError.message));

              if (validateAllFieldCriteria) {
                error[name] = validationResult;
              }
            }

          case 67:
            _i2++;
            _context.next = 55;
            break;

          case 70:
            if (isEmptyObject(validationResult)) {
              _context.next = 74;
              break;
            }

            error[name] = Object.assign({
              ref: validateRef
            }, validationResult);

            if (validateAllFieldCriteria) {
              _context.next = 74;
              break;
            }

            return _context.abrupt("return", error);

          case 74:
            return _context.abrupt("return", error);

          case 75:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateField(_x, _x2, _x3, _x4) {
    return _ref7.apply(this, arguments);
  };
}();

var getPath = function getPath(rootPath, values) {
  var paths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  for (var property in values) {
    var rootName = rootPath + (isObject(values) ? ".".concat(property) : "[".concat(property, "]"));
    isPrimitive(values[property]) ? paths.push(rootName) : getPath(rootName, values[property], paths);
  }

  return paths;
};

var assignWatchFields = function assignWatchFields(fieldValues, fieldName, watchFields, inputValue, isSingleField) {
  var value = undefined;
  watchFields.add(fieldName);

  if (!isEmptyObject(fieldValues)) {
    value = _get(fieldValues, fieldName);

    if (isObject(value) || Array.isArray(value)) {
      getPath(fieldName, value).forEach(function (name) {
        return watchFields.add(name);
      });
    }
  }

  return isUndefined(value) ? isSingleField ? inputValue : _get(inputValue, fieldName) : value;
};

var skipValidation = function skipValidation(_ref12) {
  var isOnBlur = _ref12.isOnBlur,
      isOnChange = _ref12.isOnChange,
      isOnTouch = _ref12.isOnTouch,
      isTouched = _ref12.isTouched,
      isReValidateOnBlur = _ref12.isReValidateOnBlur,
      isReValidateOnChange = _ref12.isReValidateOnChange,
      isBlurEvent = _ref12.isBlurEvent,
      isSubmitted = _ref12.isSubmitted,
      isOnAll = _ref12.isOnAll;

  if (isOnAll) {
    return false;
  } else if (!isSubmitted && isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? isReValidateOnChange : isOnChange) {
    return isBlurEvent;
  }

  return true;
};

var getFieldArrayParentName = function getFieldArrayParentName(name) {
  return name.substring(0, name.indexOf('['));
};

var isMatchFieldArrayName = function isMatchFieldArrayName(name, searchName) {
  return RegExp("^".concat(searchName, "([|.)\\d+").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
};

var isNameInFieldArray = function isNameInFieldArray(names, name) {
  return _toConsumableArray(names).some(function (current) {
    return isMatchFieldArrayName(name, current);
  });
};

var isSelectInput = function isSelectInput(element) {
  return element.type === "".concat(SELECT, "-one");
};

function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
  var observer = new MutationObserver(function () {
    for (var _i3 = 0, _Object$values = Object.values(fieldsRef.current); _i3 < _Object$values.length; _i3++) {
      var field = _Object$values[_i3];

      if (field && field.options) {
        var _iterator = _createForOfIteratorHelper(field.options),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var option = _step.value;

            if (option && option.ref && isDetached(option.ref)) {
              removeFieldEventListenerAndRef(field);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (field && isDetached(field.ref)) {
        removeFieldEventListenerAndRef(field);
      }
    }
  });
  observer.observe(window.document, {
    childList: true,
    subtree: true
  });
  return observer;
}

var isWeb = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== UNDEFINED && (typeof document === "undefined" ? "undefined" : _typeof(document)) !== UNDEFINED;

function cloneObject(data) {
  var copy;

  if (isPrimitive(data) || isWeb && (data instanceof File || isHTMLElement(data))) {
    return data;
  }

  if (data instanceof Date) {
    copy = new Date(data.getTime());
    return copy;
  }

  if (data instanceof Set) {
    copy = new Set();

    var _iterator2 = _createForOfIteratorHelper(data),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        copy.add(item);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return copy;
  }

  if (data instanceof Map) {
    copy = new Map();

    var _iterator3 = _createForOfIteratorHelper(data.keys()),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var key = _step3.value;
        copy.set(key, cloneObject(data.get(key)));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return copy;
  }

  copy = Array.isArray(data) ? [] : {};

  for (var _key in data) {
    copy[_key] = cloneObject(data[_key]);
  }

  return copy;
}

var modeChecker = function modeChecker(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched
  };
};

var isRadioOrCheckboxFunction = function isRadioOrCheckboxFunction(ref) {
  return isRadioInput(ref) || isCheckBoxInput(ref);
};

var isWindowUndefined = (typeof window === "undefined" ? "undefined" : _typeof(window)) === UNDEFINED;
var isProxyEnabled = isWeb ? 'Proxy' in window : (typeof Proxy === "undefined" ? "undefined" : _typeof(Proxy)) !== UNDEFINED;

function useForm() {
  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref13$mode = _ref13.mode,
      mode = _ref13$mode === void 0 ? VALIDATION_MODE.onSubmit : _ref13$mode,
      _ref13$reValidateMode = _ref13.reValidateMode,
      reValidateMode = _ref13$reValidateMode === void 0 ? VALIDATION_MODE.onChange : _ref13$reValidateMode,
      resolver = _ref13.resolver,
      context = _ref13.context,
      _ref13$defaultValues = _ref13.defaultValues,
      defaultValues = _ref13$defaultValues === void 0 ? {} : _ref13$defaultValues,
      _ref13$shouldFocusErr = _ref13.shouldFocusError,
      shouldFocusError = _ref13$shouldFocusErr === void 0 ? true : _ref13$shouldFocusErr,
      _ref13$shouldUnregist = _ref13.shouldUnregister,
      shouldUnregister = _ref13$shouldUnregist === void 0 ? true : _ref13$shouldUnregist,
      criteriaMode = _ref13.criteriaMode;

  var fieldsRef = useRef({});
  var fieldArrayDefaultValuesRef = useRef({});
  var fieldArrayValuesRef = useRef({});
  var watchFieldsRef = useRef(new Set());
  var useWatchFieldsRef = useRef({});
  var useWatchRenderFunctionsRef = useRef({});
  var fieldsWithValidationRef = useRef({});
  var validFieldsRef = useRef({});
  var defaultValuesRef = useRef(defaultValues);
  var isUnMount = useRef(false);
  var isWatchAllRef = useRef(false);
  var handleChangeRef = useRef();
  var shallowFieldsStateRef = useRef({});
  var resetFieldArrayFunctionRef = useRef({});
  var contextRef = useRef(context);
  var resolverRef = useRef(resolver);
  var fieldArrayNamesRef = useRef(new Set());
  var modeRef = useRef(modeChecker(mode));
  var _modeRef$current = modeRef.current,
      isOnSubmit = _modeRef$current.isOnSubmit,
      isOnTouch = _modeRef$current.isOnTouch;
  var isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;

  var _useState = useState({
    isDirty: false,
    isValidating: false,
    dirtyFields: {},
    isSubmitted: false,
    submitCount: 0,
    touched: {},
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: !isOnSubmit,
    errors: {}
  }),
      _useState2 = _slicedToArray(_useState, 2),
      formState = _useState2[0],
      setFormState = _useState2[1];

  var readFormStateRef = useRef({
    isDirty: !isProxyEnabled,
    dirtyFields: !isProxyEnabled,
    touched: !isProxyEnabled || isOnTouch,
    isValidating: !isProxyEnabled,
    isSubmitting: !isProxyEnabled,
    isValid: !isProxyEnabled
  });
  var formStateRef = useRef(formState);
  var observerRef = useRef();
  var _useRef$current = useRef(modeChecker(reValidateMode)).current,
      isReValidateOnBlur = _useRef$current.isOnBlur,
      isReValidateOnChange = _useRef$current.isOnChange;
  contextRef.current = context;
  resolverRef.current = resolver;
  formStateRef.current = formState;
  shallowFieldsStateRef.current = shouldUnregister ? {} : isEmptyObject(shallowFieldsStateRef.current) ? cloneObject(defaultValues) : shallowFieldsStateRef.current;
  var updateFormState = useCallback(function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!isUnMount.current) {
      formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
      setFormState(formStateRef.current);
    }
  }, []);

  var updateIsValidating = function updateIsValidating() {
    return readFormStateRef.current.isValidating && updateFormState({
      isValidating: true
    });
  };

  var shouldRenderBaseOnError = useCallback(function (name, error) {
    var shouldRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var isValid = arguments.length > 4 ? arguments[4] : undefined;
    var shouldReRender = shouldRender || isErrorStateChanged({
      errors: formStateRef.current.errors,
      error: error,
      name: name,
      validFields: validFieldsRef.current,
      fieldsWithValidation: fieldsWithValidationRef.current
    });

    var previousError = _get(formStateRef.current.errors, name);

    if (error) {
      unset(validFieldsRef.current, name);
      shouldReRender = shouldReRender || !previousError || !deepEqual(previousError, error, true);
      set(formStateRef.current.errors, name, error);
    } else {
      if (_get(fieldsWithValidationRef.current, name) || resolverRef.current) {
        set(validFieldsRef.current, name, true);
        shouldReRender = shouldReRender || previousError;
      }

      unset(formStateRef.current.errors, name);
    }

    if (shouldReRender && !isNullOrUndefined(shouldRender) || !isEmptyObject(state) || readFormStateRef.current.isValidating) {
      updateFormState(Object.assign(Object.assign(Object.assign({}, state), resolverRef.current ? {
        isValid: !!isValid
      } : {}), {
        isValidating: false
      }));
    }
  }, []);
  var setFieldValue = useCallback(function (name, rawValue) {
    var _fieldsRef$current$na = fieldsRef.current[name],
        ref = _fieldsRef$current$na.ref,
        options = _fieldsRef$current$na.options;
    var value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? '' : rawValue;

    if (isRadioInput(ref)) {
      (options || []).forEach(function (_ref14) {
        var radioRef = _ref14.ref;
        return radioRef.checked = radioRef.value === value;
      });
    } else if (isFileInput(ref) && !isString(value)) {
      ref.files = value;
    } else if (isMultipleSelect(ref)) {
      _toConsumableArray(ref.options).forEach(function (selectRef) {
        return selectRef.selected = value.includes(selectRef.value);
      });
    } else if (isCheckBoxInput(ref) && options) {
      options.length > 1 ? options.forEach(function (_ref15) {
        var checkboxRef = _ref15.ref;
        return checkboxRef.checked = Array.isArray(value) ? !!value.find(function (data) {
          return data === checkboxRef.value;
        }) : value === checkboxRef.value;
      }) : options[0].ref.checked = !!value;
    } else {
      ref.value = value;
    }
  }, []);
  var isFormDirty = useCallback(function (name, data) {
    if (readFormStateRef.current.isDirty) {
      var formValues = getValues();
      name && data && set(formValues, name, data);
      return !deepEqual(formValues, defaultValuesRef.current);
    }

    return false;
  }, []);
  var updateAndGetDirtyState = useCallback(function (name) {
    var shouldRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
      var isFieldDirty = !deepEqual(_get(defaultValuesRef.current, name), getFieldValue(fieldsRef, name, shallowFieldsStateRef));

      var isDirtyFieldExist = _get(formStateRef.current.dirtyFields, name);

      var previousIsDirty = formStateRef.current.isDirty;
      isFieldDirty ? set(formStateRef.current.dirtyFields, name, true) : unset(formStateRef.current.dirtyFields, name);
      var state = {
        isDirty: isFormDirty(),
        dirtyFields: formStateRef.current.dirtyFields
      };

      var isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== _get(formStateRef.current.dirtyFields, name);

      isChanged && shouldRender && updateFormState(state);
      return isChanged ? state : {};
    }

    return {};
  }, []);
  var executeValidation = useCallback( /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, skipReRender) {
      var error;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(process.env.NODE_ENV !== 'production')) {
                _context2.next = 4;
                break;
              }

              if (fieldsRef.current[name]) {
                _context2.next = 4;
                break;
              }

              console.warn('📋 Field is missing with `name` attribute: ', name);
              return _context2.abrupt("return", false);

            case 4:
              _context2.next = 6;
              return validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef);

            case 6:
              _context2.t0 = name;
              error = _context2.sent[_context2.t0];
              shouldRenderBaseOnError(name, error, skipReRender);
              return _context2.abrupt("return", isUndefined(error));

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x5, _x6) {
      return _ref16.apply(this, arguments);
    };
  }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
  var executeSchemaOrResolverValidation = useCallback( /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(names) {
      var _yield$resolverRef$cu, errors, previousFormIsValid, isInputsValid, _error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

            case 2:
              _yield$resolverRef$cu = _context3.sent;
              errors = _yield$resolverRef$cu.errors;
              previousFormIsValid = formStateRef.current.isValid;

              if (!Array.isArray(names)) {
                _context3.next = 11;
                break;
              }

              isInputsValid = names.map(function (name) {
                var error = _get(errors, name);

                error ? set(formStateRef.current.errors, name, error) : unset(formStateRef.current.errors, name);
                return !error;
              }).every(Boolean);
              updateFormState({
                isValid: isEmptyObject(errors),
                isValidating: false
              });
              return _context3.abrupt("return", isInputsValid);

            case 11:
              _error = _get(errors, names);
              shouldRenderBaseOnError(names, _error, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
              return _context3.abrupt("return", !_error);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x7) {
      return _ref17.apply(this, arguments);
    };
  }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
  var trigger = useCallback( /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name) {
      var fields, result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              fields = name || Object.keys(fieldsRef.current);
              updateIsValidating();

              if (!resolverRef.current) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return", executeSchemaOrResolverValidation(fields));

            case 4:
              if (!Array.isArray(fields)) {
                _context5.next = 11;
                break;
              }

              !name && (formStateRef.current.errors = {});
              _context5.next = 8;
              return Promise.all(fields.map( /*#__PURE__*/function () {
                var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return executeValidation(data, null);

                        case 2:
                          return _context4.abrupt("return", _context4.sent);

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x9) {
                  return _ref19.apply(this, arguments);
                };
              }()));

            case 8:
              result = _context5.sent;
              updateFormState({
                isValidating: false
              });
              return _context5.abrupt("return", result.every(Boolean));

            case 11:
              _context5.next = 13;
              return executeValidation(fields);

            case 13:
              return _context5.abrupt("return", _context5.sent);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x8) {
      return _ref18.apply(this, arguments);
    };
  }(), [executeSchemaOrResolverValidation, executeValidation]);
  var setInternalValues = useCallback(function (name, value, _ref20) {
    var shouldDirty = _ref20.shouldDirty,
        shouldValidate = _ref20.shouldValidate;
    var data = {};
    set(data, name, value);

    var _iterator4 = _createForOfIteratorHelper(getPath(name, value)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var fieldName = _step4.value;

        if (fieldsRef.current[fieldName]) {
          setFieldValue(fieldName, _get(data, fieldName));
          shouldDirty && updateAndGetDirtyState(fieldName);
          shouldValidate && trigger(fieldName);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }, [trigger, setFieldValue, updateAndGetDirtyState]);
  var setInternalValue = useCallback(function (name, value, config) {
    !shouldUnregister && !isPrimitive(value) && set(shallowFieldsStateRef.current, name, Object.assign({}, value));

    if (fieldsRef.current[name]) {
      setFieldValue(name, value);
      config.shouldDirty && updateAndGetDirtyState(name);
      config.shouldValidate && trigger(name);
    } else if (!isPrimitive(value)) {
      setInternalValues(name, value, config);

      if (fieldArrayNamesRef.current.has(name)) {
        var parentName = getFieldArrayParentName(name) || name;
        set(fieldArrayDefaultValuesRef.current, name, value);
        resetFieldArrayFunctionRef.current[parentName](_defineProperty({}, parentName, _get(fieldArrayDefaultValuesRef.current, parentName)));

        if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config.shouldDirty) {
          set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
          updateFormState({
            isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), _defineProperty({}, name, value)), defaultValuesRef.current)
          });
        }
      }
    }

    !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
  }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);

  var isFieldWatched = function isFieldWatched(name) {
    return isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
  };

  var renderWatchedInputs = function renderWatchedInputs(name) {
    var found = true;

    if (!isEmptyObject(useWatchFieldsRef.current)) {
      for (var key in useWatchFieldsRef.current) {
        if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
          useWatchRenderFunctionsRef.current[key]();
          found = false;
        }
      }
    }

    return found;
  };

  function setValue(name, value, config) {
    setInternalValue(name, value, config || {});
    isFieldWatched(name) && updateFormState();
    renderWatchedInputs(name);
  }

  handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : /*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref21) {
      var type, target, name, field, error, isValid, isBlurEvent, shouldSkipValidation, state, shouldRender, _yield$resolverRef$cu2, errors, previousFormIsValid, parentNodeName, currentError;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              type = _ref21.type, target = _ref21.target;
              name = target.name;
              field = fieldsRef.current[name];

              if (!field) {
                _context6.next = 32;
                break;
              }

              isBlurEvent = type === EVENTS.BLUR;
              shouldSkipValidation = skipValidation(Object.assign({
                isBlurEvent: isBlurEvent,
                isReValidateOnChange: isReValidateOnChange,
                isReValidateOnBlur: isReValidateOnBlur,
                isTouched: !!_get(formStateRef.current.touched, name),
                isSubmitted: formStateRef.current.isSubmitted
              }, modeRef.current));
              state = updateAndGetDirtyState(name, false);
              shouldRender = !isEmptyObject(state) || !isBlurEvent && isFieldWatched(name);

              if (isBlurEvent && !_get(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
                set(formStateRef.current.touched, name, true);
                state = Object.assign(Object.assign({}, state), {
                  touched: formStateRef.current.touched
                });
              }

              if (!shouldUnregister && isCheckBoxInput(target)) {
                set(shallowFieldsStateRef.current, name, getFieldValue(fieldsRef, name));
              }

              if (!shouldSkipValidation) {
                _context6.next = 13;
                break;
              }

              !isBlurEvent && renderWatchedInputs(name);
              return _context6.abrupt("return", (!isEmptyObject(state) || shouldRender && isEmptyObject(state)) && updateFormState(state));

            case 13:
              updateIsValidating();

              if (!resolverRef.current) {
                _context6.next = 26;
                break;
              }

              _context6.next = 17;
              return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

            case 17:
              _yield$resolverRef$cu2 = _context6.sent;
              errors = _yield$resolverRef$cu2.errors;
              previousFormIsValid = formStateRef.current.isValid;
              error = _get(errors, name);

              if (isCheckBoxInput(target) && !error && resolverRef.current) {
                parentNodeName = getFieldArrayParentName(name);
                currentError = _get(errors, parentNodeName, {});
                currentError.type && currentError.message && (error = currentError);

                if (parentNodeName && (currentError || _get(formStateRef.current.errors, parentNodeName))) {
                  name = parentNodeName;
                }
              }

              isValid = isEmptyObject(errors);
              previousFormIsValid !== isValid && (shouldRender = true);
              _context6.next = 30;
              break;

            case 26:
              _context6.next = 28;
              return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

            case 28:
              _context6.t0 = name;
              error = _context6.sent[_context6.t0];

            case 30:
              !isBlurEvent && renderWatchedInputs(name);
              shouldRenderBaseOnError(name, error, shouldRender, state, isValid);

            case 32:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x10) {
      return _ref22.apply(this, arguments);
    };
  }();

  function setFieldArrayDefaultValues(data) {
    if (!shouldUnregister) {
      var copy = cloneObject(data);

      var _iterator5 = _createForOfIteratorHelper(fieldArrayNamesRef.current),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var value = _step5.value;

          if (isKey(value) && !copy[value]) {
            copy = Object.assign(Object.assign({}, copy), _defineProperty({}, value, []));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return copy;
    }

    return data;
  }

  function getValues(payload) {
    if (isString(payload)) {
      return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
    }

    if (Array.isArray(payload)) {
      var data = {};

      var _iterator6 = _createForOfIteratorHelper(payload),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _name = _step6.value;
          set(data, _name, getFieldValue(fieldsRef, _name, shallowFieldsStateRef));
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return data;
    }

    return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister));
  }

  var validateResolver = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var values,
        _yield$resolverRef$cu3,
        errors,
        isValid,
        _args7 = arguments;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            values = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
            _context7.next = 3;
            return resolverRef.current(Object.assign(Object.assign({}, getValues()), values), contextRef.current, isValidateAllFieldCriteria);

          case 3:
            _yield$resolverRef$cu3 = _context7.sent;
            errors = _yield$resolverRef$cu3.errors;
            isValid = isEmptyObject(errors);
            formStateRef.current.isValid !== isValid && updateFormState({
              isValid: isValid
            });

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [isValidateAllFieldCriteria]);
  var removeFieldEventListener = useCallback(function (field, forceDelete) {
    return findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);
  }, [shouldUnregister]);
  var updateWatchedValue = useCallback(function (name) {
    if (isWatchAllRef.current) {
      updateFormState();
    } else {
      var _iterator7 = _createForOfIteratorHelper(watchFieldsRef.current),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var watchField = _step7.value;

          if (watchField.startsWith(name)) {
            updateFormState();
            break;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      renderWatchedInputs(name);
    }
  }, []);
  var removeFieldEventListenerAndRef = useCallback(function (field, forceDelete) {
    if (field) {
      removeFieldEventListener(field, forceDelete);

      if (shouldUnregister && !compact(field.options || []).length) {
        unset(validFieldsRef.current, field.ref.name);
        unset(fieldsWithValidationRef.current, field.ref.name);
        unset(formStateRef.current.errors, field.ref.name);
        set(formStateRef.current.dirtyFields, field.ref.name, true);
        updateFormState({
          isDirty: isFormDirty()
        });
        readFormStateRef.current.isValid && resolverRef.current && validateResolver();
        updateWatchedValue(field.ref.name);
      }
    }
  }, [validateResolver, removeFieldEventListener]);

  function clearErrors(name) {
    name && (Array.isArray(name) ? name : [name]).forEach(function (inputName) {
      return fieldsRef.current[inputName] && isKey(inputName) ? delete formStateRef.current.errors[inputName] : unset(formStateRef.current.errors, inputName);
    });
    updateFormState({
      errors: name ? formStateRef.current.errors : {}
    });
  }

  function setError(name, error) {
    var ref = (fieldsRef.current[name] || {}).ref;
    set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), {
      ref: ref
    }));
    updateFormState({
      isValid: false
    });
    error.shouldFocus && ref && ref.focus && ref.focus();
  }

  var watchInternal = useCallback(function (fieldNames, defaultValue, watchId) {
    var watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
    var fieldValues = getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, false, fieldNames);

    if (isString(fieldNames)) {
      var parentNodeName = getFieldArrayParentName(fieldNames) || fieldNames;

      if (fieldArrayNamesRef.current.has(parentNodeName)) {
        fieldValues = Object.assign(Object.assign({}, fieldArrayValuesRef.current), fieldValues);
      }

      return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(_get(defaultValuesRef.current, fieldNames)) ? defaultValue : _get(defaultValuesRef.current, fieldNames), true);
    }

    var combinedDefaultValues = isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;

    if (Array.isArray(fieldNames)) {
      return fieldNames.reduce(function (previous, name) {
        return Object.assign(Object.assign({}, previous), _defineProperty({}, name, assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)));
      }, {});
    }

    isWatchAllRef.current = isUndefined(watchId);
    return transformToNestObject(!isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
  }, []);

  function watch(fieldNames, defaultValue) {
    return watchInternal(fieldNames, defaultValue);
  }

  function unregister(name) {
    var _iterator8 = _createForOfIteratorHelper(Array.isArray(name) ? name : [name]),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var fieldName = _step8.value;
        removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }

  function registerFieldRef(ref) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (process.env.NODE_ENV !== 'production') {
      if (!ref.name) {
        return console.warn('📋 Field is missing `name` attribute', ref, "https://react-hook-form.com/api#useForm");
      }

      if (fieldArrayNamesRef.current.has(ref.name.split(/\[\d+\]$/)[0]) && !RegExp("^".concat(ref.name.split(/\[\d+\]$/)[0], "[\\d+].\\w+").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(ref.name)) {
        return console.warn('📋 `name` prop should be in object shape: name="test[index].name"', ref, 'https://react-hook-form.com/api#useFieldArray');
      }
    }

    var name = ref.name,
        type = ref.type,
        value = ref.value;
    var fieldRefAndValidationOptions = Object.assign({
      ref: ref
    }, options);
    var fields = fieldsRef.current;
    var isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
    var isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);

    var compareRef = function compareRef(currentRef) {
      return isWeb && (!isHTMLElement(ref) || currentRef === ref);
    };

    var field = fields[name];
    var isEmptyDefaultValue = true;
    var defaultValue;

    if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && compact(field.options).find(function (option) {
      return value === option.ref.value && compareRef(option.ref);
    }) : compareRef(field.ref))) {
      fields[name] = Object.assign(Object.assign({}, field), options);
      return;
    }

    if (type) {
      field = isRadioOrCheckbox ? Object.assign({
        options: [].concat(_toConsumableArray(compact(field && field.options || [])), [{
          ref: ref
        }]),
        ref: {
          type: type,
          name: name
        }
      }, options) : Object.assign({}, fieldRefAndValidationOptions);
    } else {
      field = fieldRefAndValidationOptions;
    }

    fields[name] = field;
    var isEmptyUnmountFields = isUndefined(_get(shallowFieldsStateRef.current, name));

    if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
      defaultValue = _get(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
      isEmptyDefaultValue = isUndefined(defaultValue);

      if (!isEmptyDefaultValue && !isFieldArray) {
        setFieldValue(name, defaultValue);
      }
    }

    if (!isEmptyObject(options)) {
      set(fieldsWithValidationRef.current, name, true);

      if (!isOnSubmit && readFormStateRef.current.isValid) {
        validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then(function (error) {
          var previousFormIsValid = formStateRef.current.isValid;
          isEmptyObject(error) ? set(validFieldsRef.current, name, true) : unset(validFieldsRef.current, name);
          previousFormIsValid !== isEmptyObject(error) && updateFormState();
        });
      }
    }

    if (shouldUnregister && !(isFieldArray && isEmptyDefaultValue)) {
      !isFieldArray && unset(formStateRef.current.dirtyFields, name);
    }

    if (type) {
      attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
    }
  }

  function register(refOrRegisterOptions, options) {
    if (!isWindowUndefined) {
      if (isString(refOrRegisterOptions)) {
        registerFieldRef({
          name: refOrRegisterOptions
        }, options);
      } else if (isObject(refOrRegisterOptions) && 'name' in refOrRegisterOptions) {
        registerFieldRef(refOrRegisterOptions, options);
      } else {
        return function (ref) {
          return ref && registerFieldRef(ref, refOrRegisterOptions);
        };
      }
    }
  }

  var handleSubmit = useCallback(function (onValid, onInvalid) {
    return /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
        var fieldErrors, fieldValues, _yield$resolverRef$cu4, errors, values, _i4, _Object$values2, field, _name2, fieldError;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (e && e.preventDefault) {
                  e.preventDefault();
                  e.persist();
                }

                fieldErrors = {};
                fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, true));
                readFormStateRef.current.isSubmitting && updateFormState({
                  isSubmitting: true
                });
                _context8.prev = 4;

                if (!resolverRef.current) {
                  _context8.next = 15;
                  break;
                }

                _context8.next = 8;
                return resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);

              case 8:
                _yield$resolverRef$cu4 = _context8.sent;
                errors = _yield$resolverRef$cu4.errors;
                values = _yield$resolverRef$cu4.values;
                formStateRef.current.errors = fieldErrors = errors;
                fieldValues = values;
                _context8.next = 27;
                break;

              case 15:
                _i4 = 0, _Object$values2 = Object.values(fieldsRef.current);

              case 16:
                if (!(_i4 < _Object$values2.length)) {
                  _context8.next = 27;
                  break;
                }

                field = _Object$values2[_i4];

                if (!field) {
                  _context8.next = 24;
                  break;
                }

                _name2 = field.ref.name;
                _context8.next = 22;
                return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

              case 22:
                fieldError = _context8.sent;

                if (fieldError[_name2]) {
                  set(fieldErrors, _name2, fieldError[_name2]);
                  unset(validFieldsRef.current, _name2);
                } else if (_get(fieldsWithValidationRef.current, _name2)) {
                  unset(formStateRef.current.errors, _name2);
                  set(validFieldsRef.current, _name2, true);
                }

              case 24:
                _i4++;
                _context8.next = 16;
                break;

              case 27:
                if (!(isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every(function (name) {
                  return name in fieldsRef.current;
                }))) {
                  _context8.next = 33;
                  break;
                }

                updateFormState({
                  errors: {},
                  isSubmitting: true
                });
                _context8.next = 31;
                return onValid(fieldValues, e);

              case 31:
                _context8.next = 39;
                break;

              case 33:
                formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
                _context8.t0 = onInvalid;

                if (!_context8.t0) {
                  _context8.next = 38;
                  break;
                }

                _context8.next = 38;
                return onInvalid(formStateRef.current.errors, e);

              case 38:
                shouldFocusError && focusOnErrorField(fieldsRef.current, formStateRef.current.errors);

              case 39:
                _context8.prev = 39;
                formStateRef.current.isSubmitting = false;
                updateFormState({
                  isSubmitted: true,
                  isSubmitting: false,
                  isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
                  submitCount: formStateRef.current.submitCount + 1
                });
                return _context8.finish(39);

              case 43:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[4,, 39, 43]]);
      }));

      return function (_x11) {
        return _ref24.apply(this, arguments);
      };
    }();
  }, [shouldFocusError, isValidateAllFieldCriteria]);

  var resetRefs = function resetRefs(_ref25) {
    var errors = _ref25.errors,
        isDirty = _ref25.isDirty,
        isSubmitted = _ref25.isSubmitted,
        touched = _ref25.touched,
        isValid = _ref25.isValid,
        submitCount = _ref25.submitCount,
        dirtyFields = _ref25.dirtyFields;

    if (!isValid) {
      validFieldsRef.current = {};
      fieldsWithValidationRef.current = {};
    }

    fieldArrayDefaultValuesRef.current = {};
    watchFieldsRef.current = new Set();
    isWatchAllRef.current = false;
    updateFormState({
      submitCount: submitCount ? formStateRef.current.submitCount : 0,
      isDirty: isDirty ? formStateRef.current.isDirty : false,
      isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
      isValid: isValid ? formStateRef.current.isValid : false,
      dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
      touched: touched ? formStateRef.current.touched : {},
      errors: errors ? formStateRef.current.errors : {},
      isSubmitting: false,
      isSubmitSuccessful: false
    });
  };

  var reset = function reset(values) {
    var omitResetState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (isWeb) {
      for (var _i5 = 0, _Object$values3 = Object.values(fieldsRef.current); _i5 < _Object$values3.length; _i5++) {
        var field = _Object$values3[_i5];

        if (field) {
          var _ref26 = field.ref,
              options = field.options;
          var inputRef = isRadioOrCheckboxFunction(_ref26) && Array.isArray(options) ? options[0].ref : _ref26;

          if (isHTMLElement(inputRef)) {
            try {
              inputRef.closest('form').reset();
              break;
            } catch (_a) {}
          }
        }
      }
    }

    fieldsRef.current = {};
    defaultValuesRef.current = Object.assign({}, values || defaultValuesRef.current);
    values && renderWatchedInputs('');
    Object.values(resetFieldArrayFunctionRef.current).forEach(function (resetFieldArray) {
      return isFunction(resetFieldArray) && resetFieldArray();
    });
    shallowFieldsStateRef.current = shouldUnregister ? {} : cloneObject(values || defaultValuesRef.current);
    resetRefs(omitResetState);
  };

  useEffect(function () {
    resolver && readFormStateRef.current.isValid && validateResolver();
    observerRef.current = observerRef.current || !isWeb ? observerRef.current : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
  }, [removeFieldEventListenerAndRef, defaultValuesRef.current]);
  useEffect(function () {
    return function () {
      observerRef.current && observerRef.current.disconnect();
      isUnMount.current = true;

      if (process.env.NODE_ENV !== 'production') {
        return;
      }

      Object.values(fieldsRef.current).forEach(function (field) {
        return removeFieldEventListenerAndRef(field, true);
      });
    };
  }, []);

  if (!resolver && readFormStateRef.current.isValid) {
    formState.isValid = deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && isEmptyObject(formStateRef.current.errors);
  }

  var commonProps = {
    trigger: trigger,
    setValue: useCallback(setValue, [setInternalValue, trigger]),
    getValues: useCallback(getValues, []),
    register: useCallback(register, [defaultValuesRef.current]),
    unregister: useCallback(unregister, []),
    formState: isProxyEnabled ? new Proxy(formState, {
      get: function get(obj, prop) {
        if (process.env.NODE_ENV !== 'production') {
          if (prop === 'isValid' && isOnSubmit) {
            console.warn('📋 `formState.isValid` is applicable with `onTouched`, `onChange` or `onBlur` mode. https://react-hook-form.com/api#formState');
          }
        }

        if (prop in obj) {
          readFormStateRef.current[prop] = true;
          return obj[prop];
        }

        return undefined;
      }
    }) : formState
  };
  var control = useMemo(function () {
    return Object.assign({
      isFormDirty: isFormDirty,
      updateWatchedValue: updateWatchedValue,
      shouldUnregister: shouldUnregister,
      updateFormState: updateFormState,
      removeFieldEventListener: removeFieldEventListener,
      watchInternal: watchInternal,
      mode: modeRef.current,
      reValidateMode: {
        isReValidateOnBlur: isReValidateOnBlur,
        isReValidateOnChange: isReValidateOnChange
      },
      validateResolver: resolver ? validateResolver : undefined,
      fieldsRef: fieldsRef,
      resetFieldArrayFunctionRef: resetFieldArrayFunctionRef,
      useWatchFieldsRef: useWatchFieldsRef,
      useWatchRenderFunctionsRef: useWatchRenderFunctionsRef,
      fieldArrayDefaultValuesRef: fieldArrayDefaultValuesRef,
      validFieldsRef: validFieldsRef,
      fieldsWithValidationRef: fieldsWithValidationRef,
      fieldArrayNamesRef: fieldArrayNamesRef,
      readFormStateRef: readFormStateRef,
      formStateRef: formStateRef,
      defaultValuesRef: defaultValuesRef,
      shallowFieldsStateRef: shallowFieldsStateRef,
      fieldArrayValuesRef: fieldArrayValuesRef
    }, commonProps);
  }, [defaultValuesRef.current, updateWatchedValue, shouldUnregister, removeFieldEventListener, watchInternal]);
  return Object.assign({
    watch: watch,
    control: control,
    handleSubmit: handleSubmit,
    reset: useCallback(reset, []),
    clearErrors: useCallback(clearErrors, []),
    setError: useCallback(setError, []),
    errors: formState.errors
  }, commonProps);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var FormContext = createContext(null);
FormContext.displayName = 'RHFContext';

var useFormContext = function useFormContext() {
  return useContext(FormContext);
};

var FormProvider = function FormProvider(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return createElement(FormContext.Provider, {
    value: Object.assign({}, props)
  }, children);
};

var generateId = function generateId() {
  var d = (typeof performance === "undefined" ? "undefined" : _typeof(performance)) === UNDEFINED ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

function removeAtIndexes(data, indexes) {
  var i = 0;

  var temp = _toConsumableArray(data);

  var _iterator9 = _createForOfIteratorHelper(indexes),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var index = _step9.value;
      temp.splice(index - i, 1);
      i++;
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  return compact(temp).length ? temp : [];
}

var removeArrayAt = function removeArrayAt(data, index) {
  return isUndefined(index) ? [] : removeAtIndexes(data, (Array.isArray(index) ? index : [index]).sort());
};

var moveArrayAt = function moveArrayAt(data, from, to) {
  if (Array.isArray(data)) {
    if (isUndefined(data[to])) {
      data[to] = undefined;
    }

    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
  }

  return [];
};

var swapArrayAt = function swapArrayAt(data, indexA, indexB) {
  var temp = [data[indexB], data[indexA]];
  data[indexA] = temp[0];
  data[indexB] = temp[1];
};

function prepend(data, value) {
  return [].concat(_toConsumableArray(Array.isArray(value) ? value : [value || undefined]), _toConsumableArray(data));
}

function insert(data, index, value) {
  return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(Array.isArray(value) ? value : [value || undefined]), _toConsumableArray(data.slice(index)));
}

var fillEmptyArray = function fillEmptyArray(value) {
  return Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;
};

var fillBooleanArray = function fillBooleanArray(value) {
  return (Array.isArray(value) ? value : [value]).map(function (data) {
    if (isObject(data)) {
      var object = {};

      for (var key in data) {
        object[key] = true;
      }

      return object;
    }

    return true;
  });
};

var mapIds = function mapIds() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  var skipWarn = arguments.length > 2 ? arguments[2] : undefined;

  if (process.env.NODE_ENV !== 'production') {
    if (!skipWarn) {
      var _iterator10 = _createForOfIteratorHelper(values),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var value = _step10.value;

          if (_typeof(value) === 'object') {
            if (keyName in value) {
              console.warn("\uD83D\uDCCB useFieldArray fieldValues contain the keyName `".concat(keyName, "` which is reserved for use by useFieldArray. https://react-hook-form.com/api#useFieldArray"));
              break;
            }
          } else {
            console.warn("\uD83D\uDCCB useFieldArray input's name should be in object shape instead of flat array. https://react-hook-form.com/api#useFieldArray");
            break;
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }

  return values.map(function (value) {
    return Object.assign(_defineProperty({}, keyName, value[keyName] || generateId()), value);
  });
};

var useFieldArray = function useFieldArray(_ref27) {
  var control = _ref27.control,
      name = _ref27.name,
      _ref27$keyName = _ref27.keyName,
      keyName = _ref27$keyName === void 0 ? 'id' : _ref27$keyName;
  var methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 useFieldArray is missing `control` prop. https://react-hook-form.com/api#useFieldArray');
    }
  }

  var focusIndexRef = useRef(-1);

  var _ref28 = control || methods.control,
      isFormDirty = _ref28.isFormDirty,
      updateWatchedValue = _ref28.updateWatchedValue,
      resetFieldArrayFunctionRef = _ref28.resetFieldArrayFunctionRef,
      fieldArrayNamesRef = _ref28.fieldArrayNamesRef,
      fieldsRef = _ref28.fieldsRef,
      defaultValuesRef = _ref28.defaultValuesRef,
      removeFieldEventListener = _ref28.removeFieldEventListener,
      formStateRef = _ref28.formStateRef,
      shallowFieldsStateRef = _ref28.shallowFieldsStateRef,
      updateFormState = _ref28.updateFormState,
      readFormStateRef = _ref28.readFormStateRef,
      validFieldsRef = _ref28.validFieldsRef,
      fieldsWithValidationRef = _ref28.fieldsWithValidationRef,
      fieldArrayDefaultValuesRef = _ref28.fieldArrayDefaultValuesRef,
      validateResolver = _ref28.validateResolver,
      getValues = _ref28.getValues,
      shouldUnregister = _ref28.shouldUnregister,
      fieldArrayValuesRef = _ref28.fieldArrayValuesRef;

  var getDefaultValues = function getDefaultValues(values) {
    return _get(shouldUnregister ? values : shallowFieldsStateRef.current, name, []);
  };

  var fieldArrayParentName = getFieldArrayParentName(name);
  var memoizedDefaultValues = useRef(_toConsumableArray(_get(fieldArrayDefaultValuesRef.current, fieldArrayParentName) ? getDefaultValues(fieldArrayDefaultValuesRef.current) : getDefaultValues(defaultValuesRef.current)));

  var _useState3 = useState(mapIds(memoizedDefaultValues.current, keyName)),
      _useState4 = _slicedToArray(_useState3, 2),
      fields = _useState4[0],
      setFields = _useState4[1];

  set(fieldArrayValuesRef.current, name, fields);

  var omitKey = function omitKey(fields) {
    return fields.map(function () {
      var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _b = keyName,
          omitted = _a[_b],
          rest = __rest(_a, [_typeof(_b) === "symbol" ? _b : _b + ""]);

      return rest;
    });
  };

  fieldArrayNamesRef.current.add(name);
  var getFieldArrayValue = useCallback(function () {
    return _get(fieldArrayValuesRef.current, name, []);
  }, [name]);

  var getCurrentFieldsValues = function getCurrentFieldsValues() {
    return mapIds(_get(getValues(), name, getFieldArrayValue()).map(function (item, index) {
      return Object.assign(Object.assign({}, getFieldArrayValue()[index]), item);
    }), keyName, true);
  };

  fieldArrayNamesRef.current.add(name);

  if (fieldArrayParentName && !_get(fieldArrayDefaultValuesRef.current, fieldArrayParentName)) {
    set(fieldArrayDefaultValuesRef.current, fieldArrayParentName, cloneObject(_get(defaultValuesRef.current, fieldArrayParentName)));
  }

  var setFieldAndValidState = function setFieldAndValidState(fieldsValues) {
    setFields(fieldsValues);
    set(fieldArrayValuesRef.current, name, fieldsValues);

    if (readFormStateRef.current.isValid && validateResolver) {
      var values = getValues();
      set(values, name, fieldsValues);
      validateResolver(values);
    }
  };

  var resetFields = function resetFields() {
    for (var key in fieldsRef.current) {
      if (isMatchFieldArrayName(key, name)) {
        removeFieldEventListener(fieldsRef.current[key], true);
        delete fieldsRef.current[key];
      }
    }
  };

  var cleanup = function cleanup(ref) {
    return !compact(_get(ref, name, [])).length && unset(ref, name);
  };

  var updateDirtyFieldsWithDefaultValues = function updateDirtyFieldsWithDefaultValues(updatedFieldArrayValues) {
    if (updatedFieldArrayValues) {
      set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
    }
  };

  var batchStateUpdate = function batchStateUpdate(method, args, updatedFieldValues) {
    var updatedFormValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var shouldSet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldUpdateValid = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (_get(shallowFieldsStateRef.current, name)) {
      var output = method(_get(shallowFieldsStateRef.current, name), args.argA, args.argB);
      shouldSet && set(shallowFieldsStateRef.current, name, output);
    }

    if (_get(fieldArrayDefaultValuesRef.current, name)) {
      var _output = method(_get(fieldArrayDefaultValuesRef.current, name), args.argA, args.argB);

      shouldSet && set(fieldArrayDefaultValuesRef.current, name, _output);
    }

    if (Array.isArray(_get(formStateRef.current.errors, name))) {
      var _output2 = method(_get(formStateRef.current.errors, name), args.argA, args.argB);

      shouldSet && set(formStateRef.current.errors, name, _output2);
      cleanup(formStateRef.current.errors);
    }

    if (readFormStateRef.current.touched && _get(formStateRef.current.touched, name)) {
      var _output3 = method(_get(formStateRef.current.touched, name), args.argA, args.argB);

      shouldSet && set(formStateRef.current.touched, name, _output3);
      cleanup(formStateRef.current.touched);
    }

    if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
      set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFormValues), _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
      updateDirtyFieldsWithDefaultValues(updatedFieldValues);
      cleanup(formStateRef.current.dirtyFields);
    }

    if (shouldUpdateValid && readFormStateRef.current.isValid && !validateResolver) {
      set(validFieldsRef.current, name, method(_get(validFieldsRef.current, name, []), args.argA));
      cleanup(validFieldsRef.current);
      set(fieldsWithValidationRef.current, name, method(_get(fieldsWithValidationRef.current, name, []), args.argA));
      cleanup(fieldsWithValidationRef.current);
    }

    updateFormState({
      isDirty: isFormDirty(name, omitKey(updatedFormValues))
    });
  };

  var append = function append(value) {
    var shouldFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var appendValue = Array.isArray(value) ? value : [value];
    var updateFormValues = [].concat(_toConsumableArray(getCurrentFieldsValues()), _toConsumableArray(mapIds(appendValue, keyName)));
    setFieldAndValidState(updateFormValues);

    if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
      updateDirtyFieldsWithDefaultValues(updateFormValues);
      updateFormState({
        isDirty: true,
        dirtyFields: formStateRef.current.dirtyFields
      });
    }

    !shouldUnregister && set(shallowFieldsStateRef.current, name, [].concat(_toConsumableArray(_get(shallowFieldsStateRef.current, name) || []), _toConsumableArray(cloneObject(appendValue))));
    focusIndexRef.current = shouldFocus ? _get(fieldArrayValuesRef.current, name).length - 1 : -1;
  };

  var prepend$1 = function prepend$1(value) {
    var shouldFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var emptyArray = fillEmptyArray(value);
    var updatedFieldArrayValues = prepend(getCurrentFieldsValues(), mapIds(Array.isArray(value) ? value : [value], keyName));
    setFieldAndValidState(updatedFieldArrayValues);
    resetFields();
    batchStateUpdate(prepend, {
      argA: emptyArray,
      argC: fillBooleanArray(value)
    }, updatedFieldArrayValues);
    focusIndexRef.current = shouldFocus ? 0 : -1;
  };

  var remove = function remove(index) {
    var fieldValues = getCurrentFieldsValues();
    var updatedFieldValues = removeArrayAt(fieldValues, index);
    setFieldAndValidState(updatedFieldValues);
    resetFields();
    batchStateUpdate(removeArrayAt, {
      argA: index,
      argC: index
    }, updatedFieldValues, removeArrayAt(fieldValues, index), true, true);
  };

  var insert$1 = function insert$1(index, value) {
    var shouldFocus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var emptyArray = fillEmptyArray(value);
    var fieldValues = getCurrentFieldsValues();
    var updatedFieldArrayValues = insert(fieldValues, index, mapIds(Array.isArray(value) ? value : [value], keyName));
    setFieldAndValidState(updatedFieldArrayValues);
    resetFields();
    batchStateUpdate(insert, {
      argA: index,
      argB: emptyArray,
      argC: index,
      argD: fillBooleanArray(value)
    }, updatedFieldArrayValues, insert(fieldValues, index));
    focusIndexRef.current = shouldFocus ? index : -1;
  };

  var swap = function swap(indexA, indexB) {
    var fieldValues = getCurrentFieldsValues();
    swapArrayAt(fieldValues, indexA, indexB);
    resetFields();
    setFieldAndValidState(_toConsumableArray(fieldValues));
    batchStateUpdate(swapArrayAt, {
      argA: indexA,
      argB: indexB,
      argC: indexA,
      argD: indexB
    }, undefined, fieldValues, false);
  };

  var move = function move(from, to) {
    var fieldValues = getCurrentFieldsValues();
    moveArrayAt(fieldValues, from, to);
    resetFields();
    setFieldAndValidState(_toConsumableArray(fieldValues));
    batchStateUpdate(moveArrayAt, {
      argA: from,
      argB: to,
      argC: from,
      argD: to
    }, undefined, fieldValues, false);
  };

  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        console.warn('📋 useFieldArray is missing `name` attribute. https://react-hook-form.com/api#useFieldArray');
      }
    }

    var defaultValues = _get(fieldArrayDefaultValuesRef.current, name);

    if (defaultValues && fields.length < defaultValues.length) {
      set(fieldArrayDefaultValuesRef.current, name, defaultValues.slice(1));
    }

    updateWatchedValue(name);

    if (focusIndexRef.current > -1) {
      for (var key in fieldsRef.current) {
        var field = fieldsRef.current[key];

        if (key.startsWith("".concat(name, "[").concat(focusIndexRef.current, "]")) && field.ref.focus) {
          field.ref.focus();
          break;
        }
      }
    }

    focusIndexRef.current = -1;
  }, [fields, name]);
  useEffect(function () {
    var resetFunctions = resetFieldArrayFunctionRef.current;
    var fieldArrayNames = fieldArrayNamesRef.current;

    if (!getFieldArrayParentName(name)) {
      resetFunctions[name] = function (data) {
        resetFields();
        !data && unset(fieldArrayDefaultValuesRef.current, name);
        unset(shallowFieldsStateRef.current, name);
        memoizedDefaultValues.current = _get(data || defaultValuesRef.current, name);
        setFields(mapIds(memoizedDefaultValues.current, keyName));
      };
    }

    return function () {
      if (process.env.NODE_ENV !== 'production') {
        return;
      }

      resetFields();
      delete resetFunctions[name];
      unset(fieldArrayValuesRef, name);
      fieldArrayNames.delete(name);
    };
  }, []);
  return {
    swap: useCallback(swap, [name]),
    move: useCallback(move, [name]),
    prepend: useCallback(prepend$1, [name]),
    append: useCallback(append, [name]),
    remove: useCallback(remove, [name]),
    insert: useCallback(insert$1, [name]),
    fields: fields
  };
};

var getInputValue = function getInputValue(event) {
  return isPrimitive(event) || !isObject(event.target) || isObject(event.target) && !event.type ? event : isUndefined(event.target.value) ? event.target.checked : event.target.value;
};

function useController(_ref29) {
  var name = _ref29.name,
      rules = _ref29.rules,
      defaultValue = _ref29.defaultValue,
      control = _ref29.control,
      onFocus = _ref29.onFocus;
  var methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 Controller is missing `control` prop. https://react-hook-form.com/api#Controller');
    }
  }

  var _ref30 = control || methods.control,
      defaultValuesRef = _ref30.defaultValuesRef,
      setValue = _ref30.setValue,
      register = _ref30.register,
      unregister = _ref30.unregister,
      trigger = _ref30.trigger,
      mode = _ref30.mode,
      _ref30$reValidateMode = _ref30.reValidateMode,
      isReValidateOnBlur = _ref30$reValidateMode.isReValidateOnBlur,
      isReValidateOnChange = _ref30$reValidateMode.isReValidateOnChange,
      formState = _ref30.formState,
      _ref30$formStateRef$c = _ref30.formStateRef.current,
      isSubmitted = _ref30$formStateRef$c.isSubmitted,
      touched = _ref30$formStateRef$c.touched,
      errors = _ref30$formStateRef$c.errors,
      updateFormState = _ref30.updateFormState,
      readFormStateRef = _ref30.readFormStateRef,
      fieldsRef = _ref30.fieldsRef,
      fieldArrayNamesRef = _ref30.fieldArrayNamesRef,
      shallowFieldsStateRef = _ref30.shallowFieldsStateRef;

  var isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);

  var getInitialValue = function getInitialValue() {
    return !isUndefined(_get(shallowFieldsStateRef.current, name)) && isNotFieldArray ? _get(shallowFieldsStateRef.current, name) : isUndefined(defaultValue) ? _get(defaultValuesRef.current, name) : defaultValue;
  };

  var _useState5 = useState(getInitialValue()),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setInputStateValue = _useState6[1];

  var valueRef = useRef(value);
  var ref = useRef({
    focus: function focus() {
      return null;
    }
  });
  var onFocusRef = useRef(onFocus || function () {
    if (isFunction(ref.current.focus)) {
      ref.current.focus();
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!isFunction(ref.current.focus)) {
        console.warn("\uD83D\uDCCB 'ref' from Controller render prop must be attached to a React component or a DOM Element whose ref provides a 'focus()' method");
      }
    }
  });
  var shouldValidate = useCallback(function (isBlurEvent) {
    return !skipValidation(Object.assign({
      isBlurEvent: isBlurEvent,
      isReValidateOnBlur: isReValidateOnBlur,
      isReValidateOnChange: isReValidateOnChange,
      isSubmitted: isSubmitted,
      isTouched: !!_get(touched, name)
    }, mode));
  }, [isReValidateOnBlur, isReValidateOnChange, isSubmitted, touched, name, mode]);
  var commonTask = useCallback(function (_ref31) {
    var _ref32 = _slicedToArray(_ref31, 1),
        event = _ref32[0];

    var data = getInputValue(event);
    setInputStateValue(data);
    valueRef.current = data;
    return data;
  }, []);
  var registerField = useCallback(function (shouldUpdateValue) {
    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        return console.warn('📋 Field is missing `name` prop. https://react-hook-form.com/api#Controller');
      }
    }

    if (fieldsRef.current[name]) {
      fieldsRef.current[name] = Object.assign({
        ref: fieldsRef.current[name].ref
      }, rules);
    } else {
      register(Object.defineProperties({
        name: name,
        focus: onFocusRef.current
      }, {
        value: {
          set: function set(data) {
            setInputStateValue(data);
            valueRef.current = data;
          },
          get: function get() {
            return valueRef.current;
          }
        }
      }), rules);
      shouldUpdateValue = isUndefined(_get(defaultValuesRef.current, name));
    }

    shouldUpdateValue && isNotFieldArray && setInputStateValue(getInitialValue());
  }, [rules, name, register]);
  useEffect(function () {
    return function () {
      return unregister(name);
    };
  }, [name]);
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (isUndefined(value)) {
        console.warn("\uD83D\uDCCB ".concat(name, " is missing in the 'defaultValue' prop of either its Controller (https://react-hook-form.com/api#Controller) or useForm (https://react-hook-form.com/api#useForm)"));
      }

      if (!isNotFieldArray && isUndefined(defaultValue)) {
        console.warn('📋 Controller is missing `defaultValue` prop when using `useFieldArray`. https://react-hook-form.com/api#Controller');
      }
    }

    registerField();
  }, [registerField]);
  useEffect(function () {
    !fieldsRef.current[name] && registerField(true);
  });
  var onBlur = useCallback(function () {
    if (readFormStateRef.current.touched && !_get(touched, name)) {
      set(touched, name, true);
      updateFormState({
        touched: touched
      });
    }

    shouldValidate(true) && trigger(name);
  }, [name, updateFormState, shouldValidate, trigger, readFormStateRef]);
  var onChange = useCallback(function () {
    for (var _len = arguments.length, event = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      event[_key2] = arguments[_key2];
    }

    return setValue(name, commonTask(event), {
      shouldValidate: shouldValidate(),
      shouldDirty: true
    });
  }, [setValue, name, shouldValidate]);
  return {
    field: {
      onChange: onChange,
      onBlur: onBlur,
      name: name,
      value: value,
      ref: ref
    },
    meta: Object.defineProperties({
      invalid: !!_get(errors, name)
    }, {
      isDirty: {
        get: function get() {
          return !!_get(formState.dirtyFields, name);
        }
      },
      isTouched: {
        get: function get() {
          return !!_get(formState.touched, name);
        }
      }
    })
  };
}

function useWatch(_ref33) {
  var control = _ref33.control,
      name = _ref33.name,
      defaultValue = _ref33.defaultValue;
  var methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 useWatch is missing `control` prop. https://react-hook-form.com/api#useWatch');
    }
  }

  var _ref34 = control || methods.control,
      useWatchFieldsRef = _ref34.useWatchFieldsRef,
      useWatchRenderFunctionsRef = _ref34.useWatchRenderFunctionsRef,
      watchInternal = _ref34.watchInternal,
      defaultValuesRef = _ref34.defaultValuesRef;

  var updateValue = useState()[1];
  var idRef = useRef();
  var defaultValueRef = useRef(defaultValue);
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (name === '') {
        console.warn('📋 useWatch is missing `name` attribute. https://react-hook-form.com/api#useWatch');
      }
    }

    var id = idRef.current = generateId();
    var watchFieldsHookRender = useWatchRenderFunctionsRef.current;
    var watchFieldsHook = useWatchFieldsRef.current;
    watchFieldsHook[id] = new Set();

    watchFieldsHookRender[id] = function () {
      return updateValue({});
    };

    watchInternal(name, defaultValueRef.current, id);
    return function () {
      delete watchFieldsHook[id];
      delete watchFieldsHookRender[id];
    };
  }, [name, useWatchRenderFunctionsRef, useWatchFieldsRef, watchInternal, defaultValueRef]);
  return idRef.current ? watchInternal(name, defaultValueRef.current, idRef.current) : isUndefined(defaultValue) ? isString(name) ? _get(defaultValuesRef.current, name) : Array.isArray(name) ? name.reduce(function (previous, inputName) {
    return Object.assign(Object.assign({}, previous), _defineProperty({}, inputName, _get(defaultValuesRef.current, inputName)));
  }, {}) : defaultValuesRef.current : defaultValue;
}

var Controller = function Controller(props) {
  var rules = props.rules,
      as = props.as,
      render = props.render,
      defaultValue = props.defaultValue,
      control = props.control,
      onFocus = props.onFocus,
      rest = __rest(props, ["rules", "as", "render", "defaultValue", "control", "onFocus"]);

  var _useController = useController(props),
      field = _useController.field,
      meta = _useController.meta;

  var componentProps = Object.assign(Object.assign({}, rest), field);
  return as ? isValidElement(as) ? cloneElement(as, componentProps) : createElement(as, componentProps) : render ? render(field, meta) : null;
};

export { Controller, FormProvider, appendErrors, _get as get, transformToNestObject, useController, useFieldArray, useForm, useFormContext, useWatch };